import React, { useEffect, useState, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Input, Popover, Tooltip, Typography } from "@mui/material";
import "../css/Contractor.css";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import CvAdminmilestone from "./CvAdminmilestone";
import { IoMdClose } from "react-icons/io";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { BarLoader } from "react-spinners";
import ContractImg from "./../image/agreement.png";
import { IoIosClose } from "react-icons/io";
import { Collapse } from "@mui/material";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";

const initialChange = {
  status: "",
};

function CvAdmin() {
  const navigate = useNavigate();
  const [selectedProject, setSelectedProject] = useState("");
  const [milestoneList, setMilestoneList] = useState(null);
  const [loader, setLoader] = useState(false);
  const [ownerinformation, setownerInformation] = useState(false);
  const [contractorinformation, setContractorInformation] = useState(false);
  const [projectList, setProjectList] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState({});
  const [selectedContractor, setSelectedContractor] = useState({});
  const [milestoneListdata, setMilestoneListdata] = useState([]);
  const [projectname, setProjectname] = useState("");
  const [projectid, setProjectid] = useState("");
  const [Notsigned, setNotSigned] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [changeRequest, setChangeRequest] = useState(initialChange);
  const [count, setCount] = useState({});
  const [inspectorModal, setInspectorModal] = useState(false);
  const [existedUsers, setExistedUsers] = useState([]);
  const [selectedInspector, setSelectedInspector] = useState({
    name: "",
    email: "",
  });
  const [selectedMilestone, setSelectedMilestone] = useState(null);
  const [selectedMilestoneNumber, setSelectedMilestoneNumber] = useState(null);
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isLoader, setIsLoader] = useState(false);
  const [ContractPdf, setContractPdf] = useState(false);
  const [selectedPdfFile, setSelectedPdfFile] = useState(null);
  const [projectLoaderMsg, setProjectLoaderMsg] = useState(
    "Fetching records..."
  );
  const [readOnly, setReadOnly] = useState(false);

  const [viewReport, setViewReport] = useState(false);
  const [inspectionReport, setInspectionReport] = useState([]);

  const [expanded, setExpanded] = useState({});
  const [expandInspection, setExpandInspection] = useState({});
  const [showDocuments, setShowDocuments] = useState(null);
  const [fileError, setFileError] = useState("");

  const [viewCR, setViewCR] = useState(false);
  const [viewInsHistory, setViewInsHistory] = useState(false);

  //File modal view
  const [selectedContractDoc, setSelectedContractDoc] = useState(null);
  const [ContractDocuments, setContractDocuments] = useState(false);
  const reconcileAmount =
    ((inspectionReport?.status === "Payment Initiated" ||
      inspectionReport?.status === "Awaiting Payment") &&
      inspectionReport?.change_request?.length > 0 &&
      inspectionReport.change_request[
        inspectionReport.change_request.length - 1
      ]?.revised_amount) ||
    false;
  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };

  const location = useLocation();
  const { notification } = location.state || {};

  useEffect(() => {
    setProjectLoaderMsg("Fetching records...");

    getProjectlist();
    getExistedUsers();
  }, []);

  useEffect(() => {
    if (selectedProject != "") {
      setTimeout(() => {
        const targetElement = document.getElementById("expandOfProject");

        if (targetElement) {
          targetElement.scrollIntoView({ block: "center", behavior: "smooth" });
          targetElement.style.scrollMarginTop = "100px";
        }
      }, 100);
    }
  }, [selectedProject]);

  useEffect(() => {
    if (inspectorModal) {
      if (document.getElementById("inspector_email")) {
        document.getElementById("inspector_email").focus();
      }
    }
  }, [inspectorModal]);

  useEffect(() => {
    const fetchData = async () => {
      if (!notification) return; // Ensure notification exists before making the request

      try {
        var pData = await axios.get("/cvault/get-project-detail/");
        const projectData = pData?.data?.data?.filter(
          (item) => item.project_id === notification?.project_id
        );
        const milestonedata = await axios.get(
          `/cvault/get-milestones/?project_id=${notification?.project_id}`
        );
        const MileData = milestonedata?.data?.data?.filter(
          (item) => item.id === notification?.milestone_id
        );
        if (
          notification?.title === "Inspection Request" &&
          notification?.title === MileData?.[0]?.status
        ) {
          // if(MileData[0]?.status === "Inspection Request"){
          setSelectedMilestone(notification?.milestone_id);
          // setSelectedMilestoneNumber(params?.row?.milestone_number);
          // setInspectorModal(true);
          getInspectorDetails(notification?.milestone_id);
        }
        handleMilestone(
          notification?.project_id,
          notification?.project_name,
          projectData?.[0]
        );
        handleRowClick({ row: projectData?.[0] });
        // }
        // else{
        //   toast.warning(`Project moved to ${MileData?.[0]?.status} state`)
        // }
      } catch (error) {
        toast.error("Something went wrong. Please try again later");
      }
      navigate(location.pathname, { replace: true, state: null });
    };

    fetchData(); // Ensure the function is called when notification changes
  }, [notification]);

  const controllerRef = useRef(null); // Store AbortController instance
  const toggleExpand = (msgIndex) => {
    setExpanded((prev) => ({
      ...prev,
      [msgIndex]: !prev[msgIndex],
    }));
  };

  const toggleExpandInspection = (msgIndex) => {
    setExpandInspection((prev) => ({
      ...prev,
      [msgIndex]: !prev[msgIndex],
    }));
  };

  const viewFiles = async (file, iframeShow = false) => {
    setFileError("");

    iframeShow && setShowDocuments(null);

    iframeShow ? setIsLoader(true) : setLoader(true);

    if (controllerRef.current) {
      controllerRef.current.abort();
    }

    // Create a new AbortController for the new request
    controllerRef.current = new AbortController();
    const signal = controllerRef.current.signal;

    try {
      const response = await axios.get(`cvault/file-view/?file_path=${file}`, {
        signal,
      });

      setLoader(false);
      setIsLoader(false);
      const downfunc = (response) => {
        let fileName = response?.data?.file_name;
        let base64Content = response?.data?.base64_content.trim();
        // Automatically download unsupported file types
        if (base64Content.includes(",")) {
          base64Content = base64Content.split(",")[1];
        }

        try {
          // ✅ Ensure Base64 string length is a multiple of 4
          while (base64Content.length % 4 !== 0) {
            base64Content += "=";
          }

          // ✅ Decode Base64 content
          const byteCharacters = atob(base64Content);
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], {
            type: response?.data?.mimeType,
          });

          // ✅ Create a Blob URL and trigger the download
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          // ✅ Free memory
          URL.revokeObjectURL(blobUrl);
          setShowDocuments(null);
        } catch (error) {
          console.error("Invalid Base64 content:", error);
        }
      };
      if (response?.data?.result && response?.data?.base64_content) {
        if (iframeShow) {
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response.data.file_name
            )
          ) {
            setShowDocuments(response?.data);
          } else {
            downfunc(response);
          }
        } else {
          setFileError("");
          if (
            /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
              response?.data?.file_name
            )
          ) {
            setContractDocuments(true);
            setSelectedContractDoc(response.data.base64_content);
          } else {
            downfunc(response);
          }
        }
      }
    } catch (error) {
      if (axios.isCancel(error)) {
        setIsLoader(true);
        setLoader(false);
        setFileError("");
      } else {
        setLoader(false);
        setIsLoader(false);
        iframeShow &&
          setFileError(
            error?.response?.data?.error || "File not found in cloud storage"
          );
        !iframeShow &&
          toast.error(
            error?.response?.data?.error || "File not found in cloud storage"
          );
      }
    }
  };

  const viewReports = async (id) => {
    const payload = {
      milestone_id: id,
      project_id: projectid,
    };
    setLoader(true);
    try {
      var datas = await axios.post(`/cvault/milestone-details/`, payload, {
        headers: headers,
      });
      console.log("====================================");
      console.log(datas.data.data[0]);
      console.log("====================================");
      // setFiles(datas?.data?.file_data);
      setInspectionReport(datas?.data?.data[0]);
      setViewReport(true);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  const modelStyleowner = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    boxShadow: 24,
    p: 2,
    width: "50%",
    maxHeight: "90vh", // Ensure it does not exceed viewport height
    overflowY: "auto",
  };

  var popoverStyle = {
    border: " 0px solid rgba(0, 0, 0, .2)",
    borderRadius: "2px",
    fontFamily: "Roboto,sans-serif",
    boxShadow: " 0 2px 10px rgba(0, 0, 0, .2)",
    padding: "5px 15px 10px 15px",
    lineHeight: " 24px",
    fontSize: "14px",
    width: "200px",
    height: "23vh",
    background: "white",
  };

  const iframeStyleContractPdf = {
    width: "100%",
    height: "80vh",
    border: "none", // Remove iframe border if needed
  };

  const handleRowClick = (params) => {
    setSelectedProject(params?.row); // Manually set the selected row
  };

  const getProjectlist = async () => {
    setProjectLoaderMsg("Fetching records...");
    try {
      var pData = await axios.get("/cvault/get-project-detail/");
      pData = pData?.data?.data?.map((project, index) => {
        return { ...project, id: index + 1 };
      });
      setProjectList(pData);
      setTimeout(() => {
        setProjectLoaderMsg("No projects found");
      }, 100);
    } catch (error) {
      setProjectLoaderMsg("No projects found");
      toast.error("Please try again later");
    }
  };

  const getContractPdfFile = async (id) => {
    setLoader(true);
    try {
      const data = {
        project: id,
      };
      const response = await axios.post("/cvault/get-pdf/", data, {
        headers: headers,
      });

      setLoader(false);
      setContractPdf(true);
      setSelectedPdfFile(response?.data?.base64_content);
    } catch (error) {
      setLoader(false);
      setSelectedPdfFile(null);
      toast.error(
        error?.response?.data?.error || "Unable to fetch the contract file."
      );
    }
  };

  const getInspectorDetails = async (id) => {
    try {
      const response = await axios.get(
        `/cvault/assigned-inspector/?milestone_id=${id}`
      );

      if (
        response?.data &&
        typeof response.data === "object" &&
        response?.data?.inspector &&
        response?.data?.inspection_details
      ) {
        setInspectorModal(true);
        setSelectedInspector((prev) => ({
          ...prev,
          name: response?.data?.inspector?.name,
          email: response?.data?.inspector?.email,
        }));
      } else {
        setInspectorModal(true);
        setSelectedInspector({ name: "", email: "" });
      }
    } catch (error) {
      setInspectorModal(true);
      setSelectedInspector({ name: "", email: "" });
    }
  };

  const handleStatusChange = async (val, row) => {
    setLoader(true);

    try {
      const payload = {
        project_id: row.project_id,
      };
      const api =
        val === "Awaiting Payment"
          ? "/cvault/awaiting-payment/"
          : val === "Project Initiated"
          ? "/cvault/contract-accept/"
          : "";
      const response = await axios.post(api, payload, {
        headers: headers,
      });
      getProjectlist();
      handleMilestoneModal(projectid || row?.project_id);

      if (val === "Project Initiated") {
        toast.success(`Project successfully initiated`);
      } else {
        //  toast.success(`Payment request sent to the owner`)
      }

      setLoader(false);
    } catch (error) {
      setLoader(false);

      val === "Project Initiated"
        ? toast.error(`Unable to initiate the project. Please try again.`)
        : toast.error(
            `Unable to process the payment request. Please try again.`
          );
    }
  };

  const columns = [
    { field: "id", headerName: "S.No", flex: 0, minWidth: 50, maxWidth: 50 },
    {
      headerName: "Project Name",
      field: "project_name",
      sortable: false,
      flex: 1.5,
      minWidth: 150,
      // maxWidth:150,
      renderCell: (params) => (
        <div>
          <Tooltip title={params?.row?.name}>{params?.row?.name}</Tooltip>
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Project Status",
      flex: 1.5,
      minWidth: 150,
      renderCell: (params) =>
        params?.row?.status === "Payment Initiated" ||
        params?.row?.status === "Awaiting Payment" ? (
          <select
            className="select-form-control form-control"
            value={params?.row?.status}
            style={{ width: "100%", fontSize: "14px" }}
            onChange={(e) => {
              handleStatusChange(e.target.value, params?.row);
            }}
            disabled={loader}
          >
            {/* <option value="Not Started">Not Started</option> */}
            {params?.row?.status === "Payment Initiated" && (
              <option value="Payment Initiated" disabled>
                Payment Initiated
              </option>
            )}
            <option
              value="Awaiting Payment"
              disabled={params?.row?.status === "Awaiting Payment"}
            >
              Awaiting Payment
            </option>
            <option value="Project Initiated">Initiate Project</option>
          </select>
        ) : (
          <div className="MuiDataGrid-cellContent">
            {params?.row?.status === "Not Started" ? (
              <Tooltip title={"Owner/Contractor Review"}>
                Owner/Contractor Review
              </Tooltip>
            ) : params?.row?.status === "In Progress" ? (
              "Execution Phase"
            ) : (
              params?.row?.status
            )}
          </div>
        ),
    },
    {
      field: "owner_payout",
      headerName: "Owner Payout",
      flex: 0.5,
      minWidth: 150,
      maxWidth: 150,
      renderCell: (params) =>
        params?.row?.owner_payout ? (
          <div className="MuiDataGrid-cellContent ms-4">
            {params?.row?.owner_payout}
          </div>
        ) : (
          <div className="MuiDataGrid-cellContent ms-5">-</div>
        ),
    },
    {
      field: "contractor_payout",
      headerName: "Contractor Payment",
      flex: 0.5,
      minWidth: 150,
      maxWidth: 100,
      renderCell: (params) =>
        params?.row?.contractor_payout ? (
          <div className="MuiDataGrid-cellContent m-3">
            {params?.row?.contractor_payout}
          </div>
        ) : (
          <div className="MuiDataGrid-cellContent ms-5 text-center">-</div>
        ),
    },
    {
      field: "budget",
      headerName: "Total Contract Value",
      flex: 1,
      minWidth: 150,
      // maxWidth:100,
      renderCell: (params) => (
        <div className="MuiDataGrid-cellContent ms-2">
          {params?.row?.budget}
        </div>
      ),
    },
    {
      field: "owner_name",
      headerName: "Owner",
      flex: 2,
      minWidth: 100,
      maxWidth: 120,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={() => {
            ownerinfo(params?.row);
          }}
        >
          {params?.row?.details?.owner?.owner_name}
        </div>
      ),
    },
    {
      field: "contractor_name",
      headerName: "Contractor",
      sortable: false,
      flex: 1,
      minWidth: 100,
      maxWidth: 110,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={() => {
            Contractorinfo(params?.row);
          }}
        >
          {params?.row?.details?.contractor?.contractor_name}
        </div>
      ),
    },
    {
      headerName: "Documents",
      field: "project_files",
      sortable: false,
      flex: 0.7,
      minWidth: 70,
      maxWidth: 110,
      renderCell: (params) => (
        <div className="d-flex align -items-center justify-content-between">
          <Tooltip title="View Project Contract" placement="bottom">
            <div
              class="icon"
              style={{ color: "#F5AE41", cursor: "pointer", marginLeft: "50%" }}
              onClick={() => {
                getContractPdfFile(params?.row?.project_id);
              }}
            >
              <img
                src={ContractImg}
                alt="contract"
                style={{ width: "30px", height: "30px", objectFit: "cover" }}
              />
            </div>
          </Tooltip>
        </div>
      ),
    },
    {
      headerName: "Milestones",
      field: "action",
      sortable: false,
      flex: 1,
      minWidth: 70,
      maxWidth: 100,
      renderCell: (params) => (
        <button
          className="btn detail-btn "
          onClick={() => {
            handleMilestone(
              params?.row?.project_id,
              params?.row?.name,
              params?.row
            );
          }}
          style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
        >
          View
        </button>
      ),
    },
    {
      field: "change",
      headerName: "",
      sortable: false,
      flex: 0.2,
      minWidth: 40,
      renderCell: (params) => (
        <div
          className="MuiDataGrid-cellContent text-decoration-underline pointer"
          onClick={(e) => {
            setCount(params?.row?.milestone_status_count);
            handleClick(e);
          }}
        >
          <BsThreeDotsVertical />
        </div>
      ),
    },
  ];

  const headerClassName = "custom-header";

  const renderHeader = (params) => {
    return <div className={headerClassName}>{params.colDef.headerName}</div>;
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const ownerinfo = (row) => {
    setSelectedOwner(row);
    setownerInformation(true);
  };

  const Contractorinfo = (row) => {
    setSelectedContractor(row);
    setContractorInformation(true);
  };

  const handleMilestoneModal = async (id) => {
    setProjectLoaderMsg("Fetching records...");

    setProjectid(id);
    try {
      const milestonedata = await axios.get(
        `/cvault/get-milestones/?project_id=${id}`
      );
      setMilestoneListdata(milestonedata?.data?.data);
      setTimeout(() => {
        setProjectLoaderMsg("No milestones found");
      }, 100);
      setNotSigned(milestonedata?.data?.project_status);
      getProjectlist();
    } catch (error) {
      setProjectLoaderMsg("No milestones found");
    }
  };

  const handleMilestone = (id, name, row) => {
    setSelectedProject(row);
    setProjectname(name);
    handleMilestoneModal(id);
    setMilestoneList(id);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleBlur = async (event) => {
    const inputValue = event.target.value.trim();
    if (!validateEmail(inputValue)) {
      if (inputValue !== "") {
        setEmailError("Enter a valid email");
      }
    }
    if (validateEmail(inputValue)) {
      try {
        var response = await axios.get(`/cvault/inspector-create-request/`);
        if (response.data.result) {
          const existingUsers = response.data.data.filter(
            (val) => val?.email === inputValue
          );

          const isAlreadyExisted = existingUsers.length === 1;
          setSelectedInspector((prev) => ({
            ...prev,
            name: isAlreadyExisted ? existingUsers[0]?.user_name : "",
            email: isAlreadyExisted
              ? existingUsers[0]?.email.trim()
              : inputValue.trim(),
          }));
          setReadOnly(isAlreadyExisted);
        } else {
          setSelectedInspector((prev) => ({
            ...prev,
            name: selectedInspector.name,
            email: inputValue.trim(),
          }));
          setReadOnly(false);
        }
      } catch (error) {
        if (error.response.status === 400) {
          setEmailError("Enter a valid email");
        } else {
        }
      }
    } else {
      setSelectedInspector((prev) => ({
        ...prev,
        name: "",
        email: inputValue.trim(),
      }));
    }
  };
  const assignInspector = async () => {
    // try {
    //   var response = await axios.post(
    //     "/cvault/inspector-create-request/",
    //     {
    //       user_name: selectedInspector.name,
    //       email: selectedInspector.email,
    //     },
    //     {
    //       headers: headers,
    //     }
    //   );
    //   console.log(response.data);

    //   setSelectedInspector({ name: "", email: "" });
    //   setInspectorModal(false);
    // } catch (error) {
    //   console.log(error);
    //   toast.error("Something went wrong. Please try again later");
    // }

    const existUser = existedUsers.filter(
      (v) => v.email === selectedInspector.email
    );

    const payload = {
      milestone_id: selectedMilestone,
    };
    if (existUser.length === 1) {
      payload.inspector_id = existUser[0].id;
    } else {
      payload.email = selectedInspector.email;
      payload.user_name = selectedInspector.name;
    }

    try {
      const payload = {
        milestone_id: selectedMilestone,
      };
      if (existUser.length === 1) {
        payload.inspector_id = existUser[0].id;
      } else {
        payload.email = selectedInspector.email;
        payload.user_name = selectedInspector.name;
      }
      var response = await axios.post(
        "/cvault/inspector-create-request/",
        payload,
        {
          headers: headers,
        }
      );
      getProjectlist();
      getExistedUsers();
      handleMilestoneModal(projectid);

      setSelectedInspector({ name: "", email: "" });
      setError("");

      setInspectorModal(false);
      setLoader(false); //loader
      toast.success(
        `Inspector assigned successfully for Milestone(${
          selectedMilestoneNumber || 1
        })`
      );
    } catch (error) {
      setError("");

      if (error.response.status === 400) {
        setEmailError("Enter a valid email");
      } else {
        toast.error(
          error?.response?.data?.error ||
            "Unable to assign the inspector. Please try again later."
        );
      }
      setLoader(false); //loader
    }
  };

  const getExistedUsers = async () => {
    try {
      var existedUsers = await axios.get("/cvault/inspector-create-request/");
      if (existedUsers?.data?.result) {
        setExistedUsers(existedUsers?.data?.data || []);
        existedUsers?.data?.data?.length === 0
          ? setEmailError("Please create a user before assigning an inspector.")
          : setEmailError("");
      }
    } catch (error) {
      setExistedUsers([]);
      setEmailError("Please create a user before assigning an inspector.");
    }
  };

  return (
    <div className="mt-2 p-4">
      <div className={`app-container ${loader ? "loader-container" : ""}`}>
        {loader && (
          <div className="loader-overlay">
            {" "}
            <BarLoader
              color="#F5AE41"
              width={400}
              height={10}
              className="loader"
              loading={loader}
            />
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between mx-1 mb-3">
        <div>
          <h4 className="fw-bold">Project List - Admin View</h4>
        </div>
        <div>
          <button
            className="btn btn-cvault me-2"
            onClick={() => {
              navigate("/viewusers");
            }}
          >
            View Users
          </button>
        </div>
      </div>
      <div className="card card-cvault">
        <div className="card-body" style={{ width: "100%" }}>
          <DataGrid
            rows={projectList}
            columns={columns.map((column) => ({
              ...column,
              headerClassName,
              renderHeader,
            }))}
            getRowId={(row) => row.project_id}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10, page: 0 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            onRowClick={handleRowClick}
            hideFooterSelectedRowCount
            localeText={{ noRowsLabel: projectLoaderMsg }}
          />
        </div>
      </div>
      {selectedProject !== "" ? (
        <>
          {milestoneList !== null ? (
            <div className="card card-cvault mt-4 p-3" id="expandOfProject">
              <CvAdminmilestone
                milestoneid={milestoneList}
                projectid={projectid}
                setSelectedProject={setSelectedProject}
                milestoneListdata={milestoneListdata}
                Notsigned={Notsigned}
                setMilestoneListdata={setMilestoneListdata}
                getProjectlist={getProjectlist}
                // setSelectedProject={setSelectedProject}
                projectname={projectname}
                handleMilestoneModal={handleMilestoneModal}
                setInspectorModal={setInspectorModal}
                setSelectedMilestone={setSelectedMilestone}
                setSelectedMilestoneNumber={setSelectedMilestoneNumber}
                getInspectorDetails={getInspectorDetails}
                projectLoaderMsg={projectLoaderMsg}
                viewReports={viewReports}
              />
            </div>
          ) : null}
        </>
      ) : null}

      <Modal
        open={ownerinformation}
        onClose={() => setownerInformation(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, width: "40%" }}>
          {selectedOwner ? (
            <div>
              <div className="d-flex justify-content-between">
                <h5>Owner Information</h5>
                <IoMdClose
                  className="fs-5 cursor"
                  onClick={() => {
                    setownerInformation(false);
                  }}
                />
              </div>
              <div className="dropdown-divider"></div>

              <div className="mt-3 ">
                <div className="row d-flex">
                  <div className="col-md-3">
                    <b>Name</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.details?.owner?.owner_name}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Co-Owner Name</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.details?.owner?.co_owner_name || "---"}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Phone</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.details?.owner?.contact_info}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-3">
                    <b>Email</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-8">
                    {selectedOwner?.details?.owner?.email}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </Box>
      </Modal>

      <Modal
        open={ContractPdf}
        onClose={() => {
          setContractPdf(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            borderRadius: "5px",
            boxShadow: 24,
            width: "70%",
            height: "90%",
            overflowY: "auto",
          }}
        >
          <div>
            <div
              style={{
                position: "sticky",
                top: "0",
                zIndex: 2,
                backgroundColor: "white",
                borderBottom: "1px solid lightgray",
              }}
              className="d-flex justify-content-between ps-4 pe-2 pt-2"
            >
              <div>
                <h5>Project Contract</h5>
              </div>
              <IoIosClose
                className="fs-1 cursor"
                onClick={() => {
                  setContractPdf(false);
                }}
              />
            </div>

            <div style={{ padding: "0px 16px" }}>
              {selectedPdfFile && (
                <iframe
                  title="PDF Viewer"
                  style={iframeStyleContractPdf}
                  src={selectedPdfFile}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={contractorinformation}
        onClose={() => setContractorInformation(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modelStyleowner}>
          {selectedContractor ? (
            <div>
              <div className="d-flex justify-content-between">
                <h4>Contractor Information</h4>
                <IoMdClose
                  className="fs-4 cursor"
                  onClick={() => {
                    setContractorInformation(false);
                  }}
                />
              </div>
              <div className="dropdown-divider"></div>

              <div className=" mt-3 ">
                <div className="row d-flex">
                  <div className="col-md-2">
                    <b>Name</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-9">
                    {selectedContractor?.details?.contractor?.contractor_name}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-2">
                    <b>Phone</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-9">
                    {selectedContractor?.details?.contractor?.contact_info}
                  </div>
                </div>
                <div className="row d-flex mt-2">
                  <div className="col-md-2">
                    <b>Email</b>
                  </div>
                  <div className="col-md-1">
                    <b>:</b>
                  </div>
                  <div className="col-md-9">
                    {selectedContractor?.details?.contractor?.email}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
        </Box>
      </Modal>

      <Modal
        open={inspectorModal}
        onClose={() => {
          setInspectorModal(false);
          setSelectedInspector({ name: "", email: "" });
          setError("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ ...modelStyleowner, width: "40%" }}>
          <div>
            <div className="d-flex align-items-center justify-content-between">
              <h5>Assign Inspector</h5>
              <IoMdClose
                className="fs-5 cursor"
                onClick={() => {
                  setInspectorModal(false);
                  setSelectedInspector({ name: "", email: "" });
                  setError("");
                }}
              />
            </div>
            <div className="dropdown-divider"></div>
            <div className=" mt-3">
              <div className="row d-flex mt-2">
                <div className="col">
                  <label className="fs-6">
                    Email<span className="text-danger fs-4">*</span>
                  </label>
                  <div>
                    <select
                      id="inspector_email"
                      value={selectedInspector.email}
                      onChange={(e) => {
                        const selectedEmail = e.target.value;
                        setSelectedInspector((prev) => ({
                          ...prev,
                          email: selectedEmail,
                        }));
                        handleBlur(e);
                        setError("");
                        setEmailError("");
                      }}
                      style={{
                        height: "35px",
                        marginTop: "7px",
                        border: "1px solid lightgrey",
                        borderRadius: "2px",
                        marginBottom: "5px",
                        marginTop: "2px",
                        width: "100%",
                        boxSizing: "border-box",
                        color: "##2C3E50",
                        fontSize: "14px",
                        letterSpacing: "1px",
                        padding: "2px 4px",
                      }}
                      // onBlur={handleBlur}
                      disabled={existedUsers.length === 0} // disable if no users
                    >
                      {existedUsers.length === 0 ? (
                        <option value="">No Inspector(s) found</option>
                      ) : (
                        <>
                          <option value="">Select an inspector</option>
                          {existedUsers.map((user) => (
                            <option key={user.id} value={user.email}>
                              {user.email}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <div className="row d-flex">
                <div className="col">
                  <label className="fs-6">
                    Name<span className="text-danger fs-4">*</span>
                  </label>
                  <div>
                    <input
                      type="text"
                      value={selectedInspector.name}
                      onChange={(e) => {
                        setError("");
                        setSelectedInspector((prev) => ({
                          ...prev,
                          name: e.target.value,
                        }));
                      }}
                      style={{
                        height: "35px",
                        marginTop: "7px",
                        padding: "2px 8px",
                      }}
                      placeholder="Name"
                      readOnly={readOnly}
                      disabled
                    />
                  </div>
                </div>
              </div>
              {error && (
                <div style={{ fontSize: "14px" }} className="text-danger">
                  {error}
                </div>
              )}
              {emailError && (
                <div style={{ fontSize: "14px" }} className="text-danger">
                  {emailError}
                </div>
              )}
              <div className="row d-flex mt-2">
                <div className="col text-end">
                  <button
                    className="btn btn-cvault"
                    style={{ fontSize: "14px", fontWeight: 400 }}
                    onClick={() => {
                      if (
                        selectedInspector.name.trim() !== "" &&
                        selectedInspector.email.trim() !== ""
                      ) {
                        setLoader(true); //loader
                        assignInspector();
                      } else {
                        setError(
                          existedUsers?.length === 0
                            ? "Please create a user before assigning an inspector."
                            : "Please fill out all the fields."
                        );
                      }
                    }}
                    disabled={isLoader}
                  >
                    {isLoader && <span className="round_loader" />}{" "}
                    <span style={{ marginLeft: isLoader ? "5px" : "" }}>
                      Assign
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={viewReport}
        onClose={() => {
          setViewReport(false);
          setShowDocuments(null);
          setViewCR(false);
          setViewInsHistory(false);
          setExpanded({});
          setExpandInspection({});
          setFileError("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{ ...modelStyleowner, width: "50%", top: "50%", height: "85%" }}
        >
          <div>
            <div>
              <div className="d-flex justify-content-between">
                <h5>View Details</h5>
                <IoMdClose
                  className="fs-5 cursor"
                  onClick={() => {
                    setViewReport(false);
                    setShowDocuments(null);
                    setViewCR(false);
                    setViewInsHistory(false);
                    setExpanded({});
                    setExpandInspection({});
                    setFileError("");
                  }}
                />
              </div>
              <div className="dropdown-divider"></div>
              <div className="">
                <div className="mb-2 d-flex">
                  <label
                    className="milestonechangeRequest"
                    style={{ width: reconcileAmount ? "38%" : "30%" }}
                  >
                    Project{" "}
                  </label>
                  <div
                    style={{ width: reconcileAmount ? "62%" : "70%" }}
                    className="text-primary"
                  >
                    {" : "}
                    {projectname}
                  </div>
                </div>
                <div className="mb-2 d-flex">
                  <label
                    className="milestonechangeRequest"
                    style={{ width: reconcileAmount ? "38%" : "30%" }}
                  >
                    Milestone{" "}
                  </label>
                  <div
                    style={{ width: reconcileAmount ? "62%" : "70%" }}
                    className="text-primary"
                  >
                    {" : "}
                    {inspectionReport.milestone_number ||
                      selectedMilestoneNumber +
                        ". " +
                        inspectionReport.milestone}
                  </div>
                </div>
                {inspectionReport?.original_amount && (
                  <div className="mb-2 d-flex">
                    <label
                      className="milestonechangeRequest"
                      style={{ width: reconcileAmount ? "38%" : "30%" }}
                    >
                      Original Amount{" "}
                    </label>
                    <div
                      style={{ width: reconcileAmount ? "62%" : "70%" }}
                      className="text-primary"
                    >
                      {" : "}
                      {"$" +
                        inspectionReport?.original_amount
                          ?.replace("$$", "$")
                          .replace(".00", "")}
                    </div>
                  </div>
                )}

                {inspectionReport?.milestone_amount && (
                  <div className="mb-2 d-flex">
                    <label
                      className="milestonechangeRequest"
                      style={{ width: reconcileAmount ? "38%" : "30%" }}
                    >
                      {reconcileAmount ? "Last Approved Amount " : "Amount "}
                    </label>
                    <div
                      style={{ width: reconcileAmount ? "62%" : "70%" }}
                      className="text-primary"
                    >
                      {" : "}
                      {inspectionReport.milestone_amount.includes("$")
                        ? inspectionReport.milestone_amount
                        : "$" +
                          inspectionReport?.milestone_amount
                            ?.replace("$$", "$")
                            .replace(".00", "")}
                    </div>
                  </div>
                )}

                {(inspectionReport?.status === "Payment Initiated" ||
                  inspectionReport?.status === "Awaiting Payment") &&
                  inspectionReport?.change_request?.length > 0 && (
                    <div className="mb-2 d-flex">
                      <label
                        className="milestonechangeRequest"
                        style={{ width: reconcileAmount ? "38%" : "30%" }}
                      >
                        CR Amount to be reconciled (#
                        {inspectionReport.change_request.length})
                      </label>
                      <div
                        style={{ width: reconcileAmount ? "62%" : "70%" }}
                        className="text-primary"
                      >
                        {" : "}
                        <span style={{ color: "#07ab04a1" }}>
                          {" "}
                          {inspectionReport.change_request[
                            inspectionReport.change_request.length - 1
                          ]?.revised_amount?.replace(".00", "")}
                        </span>
                      </div>
                    </div>
                  )}

                {/* {inspectionReport?.compliance_comments && (
                  <div className="mb-2">
                    <label
                      className="milestonechangeRequest"
                      style={{ width: "35%" }}
                    >
                      Compliant Notes
                    </label>
                    <span className="text-center ">
                      {" : " + inspectionReport?.compliance_comments}
                    </span>
                  </div>
                )}
                {inspectionReport?.non_compliance_comments && (
                  <div className=" mb-2">
                    <label
                      className="milestonechangeRequest"
                      style={{ width: "35%" }}
                    >
                      Non-compliant Notes
                    </label>
                    <span className="text-center  ">
                      {" : " + inspectionReport?.non_compliance_comments}
                    </span>
                  </div>
                )} */}

                <div className="mb-2">
                  <label className="milestonechangeRequest">
                    Milestone Description{" "}
                  </label>
                  <span className=" ">
                    <div
                      style={{
                        marginTop: "10px",
                        overflowY: "auto",
                        overflowX: "hidden",
                        maxHeight: "300px",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        // fontFamily: "sans-serif",
                        height: "auto",
                        marginBottom: "0px",
                      }}
                    >
                      <div>{inspectionReport.milestone_description}</div>
                      {inspectionReport?.change_request?.length > 0 && (
                        <div
                          onClick={() => {
                            setViewCR(!viewCR);
                          }}
                          style={{ cursor: "pointer" }}
                          className="d-flex align-items-center mt-1"
                        >
                          <span
                            style={{
                              transition: "transform 0.3s ease",
                              fontSize: "10px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              viewBox="0 0 512 512"
                              width={15}
                              height={15}
                              style={{
                                enableBackground: "new 0 0 512 512",
                              }}
                              xmlSpace="preserve"
                            >
                              <g>
                                <path
                                  d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                  fill={"#000"}
                                />
                              </g>
                            </svg>
                          </span>
                          <span
                            className="ms-2 text-primary"
                            style={{
                              color: !viewCR ? "#0d6efd" : "lightgray",
                            }}
                          >
                            {!viewCR
                              ? "View Change Request History"
                              : "Close Change Request History"}
                          </span>
                        </div>
                      )}

                      {viewCR && (
                        <div
                          style={{
                            borderLeft: "2px solid lightgray",
                            marginLeft: "7px",
                          }}
                        >
                          <div
                            style={{
                              marginLeft: viewCR ? "25px" : "0px",
                            }}
                          >
                            {inspectionReport?.change_request?.length > 0 &&
                              inspectionReport?.change_request.map(
                                (request, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      marginTop: "5px",
                                    }}
                                  >
                                    <strong>
                                      {request?.change_request_heading}
                                      {":"}
                                    </strong>
                                    <div>
                                      {"Initiated Date: " +
                                        request?.initiate_date}
                                    </div>
                                    <div>
                                      {
                                        request?.change_request_description?.[0]
                                          ?.user_name
                                      }{" "}
                                      (
                                      {
                                        request?.change_request_description?.[0]
                                          ?.user_role
                                      }
                                      ) initiated a change request
                                    </div>
                                    {request?.change_request_description?.map(
                                      (msg, msgIndex) => (
                                        <div>
                                          <div key={msgIndex}>
                                            <span>
                                              {msg?.user_name} ({msg?.user_role}
                                              ): {msg?.message}
                                            </span>

                                            {msg?.files_path?.length > 0 && (
                                              <div
                                                style={{
                                                  display: "flex",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <Tooltip
                                                  title={
                                                    !expanded[msgIndex]
                                                      ? "Click to expand files"
                                                      : "Click to collpase files"
                                                  }
                                                  placement="right"
                                                >
                                                  <div
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    className="d-flex align-items-center"
                                                    onClick={() =>
                                                      toggleExpand(msgIndex)
                                                    }
                                                  >
                                                    <span
                                                      style={{
                                                        transition:
                                                          "transform 0.3s ease",

                                                        fontSize: "10px",
                                                      }}
                                                    >
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        version="1.1"
                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                        viewBox="0 0 512 512"
                                                        width={15}
                                                        height={15}
                                                        style={{
                                                          marginBottom: "4px",
                                                          enableBackground:
                                                            "new 0 0 512 512",
                                                        }}
                                                        xmlSpace="preserve"
                                                      >
                                                        <g>
                                                          <path
                                                            d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                            fill={"#000"}
                                                          />
                                                        </g>
                                                      </svg>
                                                      <span
                                                        className="text-primary"
                                                        style={{
                                                          fontSize: "13px",
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        {msg?.files_path
                                                          ?.length === 1
                                                          ? "1 document"
                                                          : `${msg?.files_path?.length} documents`}
                                                      </span>
                                                    </span>
                                                  </div>
                                                </Tooltip>
                                              </div>
                                            )}
                                          </div>
                                          <Collapse
                                            in={expanded[msgIndex]}
                                            style={{
                                              marginLeft: "5px",
                                            }}
                                          >
                                            <ol
                                              style={{
                                                marginBottom: "0rem",
                                                paddingLeft: "10px",
                                              }}
                                            >
                                              {msg?.files_path?.map(
                                                (file, fileIndex) => (
                                                  <li key={fileIndex}>
                                                    <span
                                                      style={{
                                                        cursor: "pointer",
                                                        textDecoration:
                                                          "underline",
                                                      }}
                                                      onClick={() => {
                                                        viewFiles(file, true);
                                                      }}
                                                    >
                                                      <i>
                                                        {file.split("/").pop()}
                                                      </i>
                                                    </span>
                                                  </li>
                                                )
                                              )}
                                            </ol>
                                          </Collapse>
                                        </div>
                                      )
                                    )}

                                    {request?.revised_amount !== null && (
                                      <div>
                                        Amount:{" "}
                                        {request?.revised_amount
                                          .replace("$$", "$")
                                          .replace(".00", "")}
                                      </div>
                                    )}
                                    <div>
                                      {request?.accepted_date
                                        ? "Accepted date: "
                                        : "Denied date: "}
                                      {request?.accepted_date ||
                                        request?.denied_date}
                                    </div>
                                    <div>
                                      {request?.accepted_denied_by}{" "}
                                      <strong>
                                        {request?.accepted_date
                                          ? "accepted"
                                          : "denied"}
                                      </strong>{" "}
                                      the change request
                                    </div>
                                  </div>
                                )
                              )}
                          </div>
                        </div>
                      )}

                      {inspectionReport?.inspection_details?.length > 0 && (
                        <div
                          onClick={() => {
                            setViewInsHistory(!viewInsHistory);
                          }}
                          style={{ cursor: "pointer" }}
                          className="d-flex align-items-center mt-1"
                        >
                          <span
                            style={{
                              transition: "transform 0.3s ease",
                              fontSize: "10px",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              version="1.1"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              viewBox="0 0 512 512"
                              width={15}
                              height={15}
                              style={{
                                enableBackground: "new 0 0 512 512",
                              }}
                              xmlSpace="preserve"
                            >
                              <g>
                                <path
                                  d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                  fill={"#000"}
                                />
                              </g>
                            </svg>
                          </span>
                          <span
                            className="ms-2 text-primary"
                            style={{
                              color: !viewInsHistory ? "#0d6efd" : "lightgray",
                            }}
                          >
                            {!viewInsHistory
                              ? "View Inspection History"
                              : "Close Inspection History"}
                          </span>
                        </div>
                      )}

                      {viewInsHistory &&
                        inspectionReport?.inspection_details?.length > 0 && (
                          <div
                            style={{
                              borderLeft: "2px solid lightgray",
                              marginLeft: "7px",
                            }}
                          >
                            <div
                              style={{
                                marginLeft: viewInsHistory ? "25px" : "0px",
                              }}
                            >
                              {inspectionReport?.inspection_details?.map(
                                (inspection, index) => (
                                  <div key={index}>
                                    <strong>
                                      Inspection {inspection.inspection_number}:
                                    </strong>
                                    {inspection?.requested_date && (
                                      <div>
                                        Requested date:{" "}
                                        {inspection.requested_date}{" "}
                                      </div>
                                    )}

                                    {inspection?.submission_date && (
                                      <div>
                                        Submission date:{" "}
                                        {inspection.submission_date}{" "}
                                      </div>
                                    )}
                                    <div>
                                      Inspection Status:{" "}
                                      {inspection?.compliance_status === "meets"
                                        ? "Compliant"
                                        : "Non-Compliant"}{" "}
                                    </div>
                                    {inspection?.compliance_comments && (
                                      <div>
                                        Compliance Notes:{" "}
                                        {inspection.compliance_comments}{" "}
                                      </div>
                                    )}
                                    {inspection?.non_compliance_comments && (
                                      <div>
                                        Non-compliance Notes:{" "}
                                        {inspection.non_compliance_comments}{" "}
                                      </div>
                                    )}
                                    {inspection?.inspector && (
                                      <div>
                                        Inspector Name: {inspection.inspector}{" "}
                                      </div>
                                    )}

                                    {inspection?.file_data?.length > 0 && (
                                      <div>
                                        <Tooltip
                                          title={
                                            !expandInspection[index]
                                              ? "Click to expand files"
                                              : "Click to collpase files"
                                          }
                                          placement="right"
                                        >
                                          <div
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            className="d-flex align-items-center"
                                            onClick={() =>
                                              toggleExpandInspection(index)
                                            }
                                          >
                                            <span
                                              style={{
                                                transition:
                                                  "transform 0.3s ease",

                                                fontSize: "10px",
                                              }}
                                            >
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                version="1.1"
                                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                                viewBox="0 0 512 512"
                                                width={15}
                                                height={15}
                                                style={{
                                                  marginBottom: "4px",
                                                  enableBackground:
                                                    "new 0 0 512 512",
                                                }}
                                                xmlSpace="preserve"
                                              >
                                                <g>
                                                  <path
                                                    d="M420.608 311.463 512 259l-96.612-55.463L512 148.073 256 1.109 0 148.073l96.612 55.463L0 259l91.39 52.463L0 363.927 256 510.89l256-146.963-91.392-52.464zM80.29 148.073 256 47.201l175.71 100.871L256 248.943 80.29 148.073zm0 110.925 56.468-32.417L256 295.035l119.242-68.454 56.468 32.417L256 359.868 80.29 258.998zm0 104.929 51.246-29.419L256 405.96l124.464-71.452 51.246 29.419L256 464.798 80.29 363.927z"
                                                    fill={"#000"}
                                                  />
                                                </g>
                                              </svg>
                                              <span
                                                className="text-primary"
                                                style={{
                                                  fontSize: "13px",
                                                  marginLeft: "5px",
                                                }}
                                              >
                                                {inspection.file_data
                                                  ?.length === 1
                                                  ? "1 document"
                                                  : `${inspection.file_data?.length} documents`}
                                              </span>
                                            </span>
                                          </div>
                                        </Tooltip>

                                        <Collapse
                                          in={expandInspection[index]}
                                          style={{
                                            marginLeft: "5px",
                                          }}
                                        >
                                          <ol
                                            style={{
                                              marginBottom: "0rem",
                                              paddingLeft: "10px",
                                              // fontSize: "13px",
                                            }}
                                          >
                                            {inspection.file_data.map(
                                              (file, fileIndex) => (
                                                <li
                                                  key={fileIndex}
                                                  style={{
                                                    marginTop: "5px",
                                                  }}
                                                >
                                                  <span
                                                    style={{
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      viewFiles(file, true)
                                                    }
                                                  >
                                                    <i>
                                                      {file.split("/").pop()}
                                                    </i>
                                                  </span>
                                                </li>
                                              )
                                            )}
                                          </ol>
                                        </Collapse>
                                      </div>
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}
                    </div>
                  </span>
                </div>

                {/* {files.length > 0 && (
                  <div className="">
                    <label className="milestonechangeRequest">
                      Attached Inspection Reports
                    </label>
                  </div>
                )}
                <div
                  className="grid-container"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(90px, 1fr))",
                    gap: "0px",
                    padding: "0px 12px",
                    overflowX: "auto",
                  }}
                >
                  {files?.map((item, index) => (
                    <div
                      key={index}
                      className="preview-item group relative text-sm text-token-text-primary view_files"
                      style={{
                        display: "grid",
                        alignItems: "center",
                        justifyItems: "center",
                        background: "#fff",
                        borderRadius: "2px",
                      }}
                    >
                      <div className="relative overflow-hidden border-token-border-light bg-token-main-surface-primary rounded-xl view_files">
                        <div className="text-center">
                          {(item?.type?.includes("image") ||
                            (typeof item === "string" &&
                              /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                                item
                              ))) && (
                            <Tooltip
                              placement="top"
                              title="click to view image"
                            >
                              <div
                                style={{
                                  color: "gray",
                                  cursor: "pointer",
                                }}
                                className="gap-2"
                                onClick={() => {
                                  if (item?.type) {
                                    setContractDocuments(true);
                                    setSelectedContractDoc(
                                      URL.createObjectURL(item.blob)
                                    );
                                  } else {
                                    viewFiles(item, true);
                                  }
                                }}
                              >
                                <TextSnippetIcon
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    color: "rgb(128 175 215)",
                                    opacity: "0.9",
                                  }}
                                  className="relative h-10 w-10 shrink-0 overflow-hidden rounded-lg"
                                />
                              </div>
                            </Tooltip>
                          )}
                          {(item?.type === "video" ||
                            item?.type === "video/mp4" ||
                            (typeof item === "string" &&
                              /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                                item
                              ))) && (
                            <div
                              style={{
                                color: "gray",
                                cursor: "pointer",
                              }}
                              className="gap-2"
                              onClick={() => {
                                viewFiles(item, true);
                              }}
                            >
                              <TextSnippetIcon
                                style={{
                                  width: "25px",
                                  height: "25px",
                                  color: "rgb(128 175 215)",
                                  opacity: "0.9",
                                }}
                              />
                            </div>
                          )}

                          {(item?.type?.includes("pdf") ||
                            (typeof item === "string" &&
                              item.includes("pdf"))) && (
                            <Tooltip
                              title={`Click to view pdf`}
                              placement="top"
                            >
                              <div
                                style={{
                                  color: "gray",
                                  cursor: "pointer",
                                }}
                                className="gap-2"
                                onClick={() => {
                                  if (item?.type) {
                                    setContractDocuments(true);
                                    setSelectedContractDoc(
                                      URL.createObjectURL(item.blob)
                                    );
                                  } else {
                                    viewFiles(item, true);
                                  }
                                }}
                              >
                                <TextSnippetIcon
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    color: "rgb(128 175 215)",
                                    opacity: "0.9",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          )}

                          {(item?.type === "text" ||
                            (typeof item === "string" &&
                              /\.(txt)$/i.test(item))) && (
                            <Tooltip
                              title={`Click to view text`}
                              placement="top"
                            >
                              <div
                                style={{
                                  color: "gray",
                                  cursor: "pointer",
                                }}
                                className="gap-2"
                                onClick={() => {
                                  if (item?.type) {
                                    setContractDocuments(true);
                                    setSelectedContractDoc(
                                      URL.createObjectURL(item.blob)
                                    );
                                  } else {
                                    viewFiles(item, true);
                                  }
                                }}
                              >
                                <TextSnippetIcon
                                  style={{
                                    width: "25px",
                                    height: "25px",
                                    color: "rgb(128 175 215)",
                                    opacity: "0.9",
                                  }}
                                />
                              </div>
                            </Tooltip>
                          )}

                          {(item?.type === "other" ||
                            /\.(?!jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico|pdf|txt|mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)([a-z0-9]+)$/i.test(
                              item
                            )) &&
                            typeof item === "string" && (
                              <Tooltip title={`Click to view`} placement="top">
                                <div
                                  style={{
                                    color: "gray",
                                    cursor: "pointer",
                                  }}
                                  className="gap-2"
                                  onClick={() => {
                                    if (item?.type) {
                                      setContractDocuments(true);
                                      setSelectedContractDoc(
                                        URL.createObjectURL(item.blob)
                                      );
                                    } else {
                                      viewFiles(item, true);
                                    }
                                  }}
                                >
                                  <TextSnippetIcon
                                    style={{
                                      width: "25px",
                                      height: "25px",
                                      color: "rgb(128 175 215)",
                                      opacity: "0.9",
                                    }}
                                  />
                                </div>
                              </Tooltip>
                            )}

                          <div
                            style={{
                              fontSize: "13px",
                              marginRight: "3px",
                              marginLeft: "2px",
                              marginTop: "10px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              viewFiles(item, true);
                            }}
                          >
                            {(() => {
                              const fileName = (item.name || item)
                                .split("/")
                                .pop(); // Extract filename from path
                              if (fileName.length > 9) {
                                return (
                                  fileName.replace(/ /g, "").slice(0, 5) +
                                  "..." +
                                  fileName.replace(/ /g, "").slice(-4)
                                );
                              }
                              return fileName.replace(/ /g, "");
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div> */}
                {isLoader && (
                  <div className="mt-2">
                    <div
                      className="text-center mb-3"
                      style={{ fontSize: "13px", color: "#F5AE41" }}
                    >
                      Fetching document from cloud storage. Please wait...
                    </div>

                    <BarLoader
                      color="#F5AE41"
                      width={"80%"}
                      height={5}
                      className="loader"
                      loading={isLoader}
                    />
                  </div>
                )}
                {showDocuments && (
                  <div
                    style={{
                      padding: "0px 10px",
                      width: "100%",
                      height: "auto",
                    }}
                  >
                    <label className="mb-2" style={{ fontSize: "14px" }}>
                      Selected Document :{" "}
                      <span className="text-primary">
                        {showDocuments.file_name}
                      </span>
                    </label>

                    {typeof showDocuments.base64_content === "string" &&
                      /\.(jpg|jpeg|png|gif|bmp|webp|svg|tiff|ico)$/i.test(
                        showDocuments.file_name
                      ) && (
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}
                    {typeof showDocuments.base64_content === "string" &&
                      /\.(pdf)$/i.test(showDocuments.file_name) && (
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}

                    {typeof showDocuments.base64_content === "string" &&
                      /\.(mp4|mov|wmv|avi|flv|mkv|webm|mpeg|mpg)$/i.test(
                        showDocuments.file_name
                      ) && (
                        <video
                          style={{ width: "100%", height: "60vh" }}
                          controls
                          src={showDocuments.base64_content}
                        ></video>
                      )}

                    {typeof showDocuments.base64_content === "string" &&
                      /\.(txt)$/i.test(showDocuments.file_name) && (
                        <iframe
                          style={{ width: "100%", height: "60vh" }}
                          src={showDocuments.base64_content}
                        ></iframe>
                      )}
                  </div>
                )}
                {fileError !== "" && (
                  <div className="text-danger text-center">{fileError}</div>
                )}
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        // className="ms-5"
        anchorOrigin={{
          vertical: "center", // Center vertically
          horizontal: "left", // Align to the right side
        }}
        transformOrigin={{
          vertical: "center", // Center vertically
          horizontal: "right", // Align to the left side
        }}
        style={{ borderRadius: "5px", marginLeft: "-1%" }}
      >
        <Typography style={popoverStyle}>
          <div className="text-center  d-flex justify-content-center h-100 align-items-center ">
            <div>
              <p className="fw-bold fs-6">Milestone(s) Recap</p>
              {Object.entries(count || {}).map(([key, value]) => {
                const spacing =
                  key === "Inspection Phase"
                    ? "22px"
                    : key === "Completed"
                    ? "64px"
                    : "60px";

                return (
                  <span className="admininspection" key={key}>
                    {key}
                    <span style={{ marginLeft: spacing }} />
                    {value}
                  </span>
                );
              })}
            </div>
          </div>
        </Typography>
      </Popover>
    </div>
  );
}

export default CvAdmin;
